import { createContext } from 'react';

const liveanalytic = createContext();

export default liveanalytic;
